// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2xSzn","header":"MessagesList_header__1pKti","chat":"MessagesList_chat__IASl8"};